import { render, staticRenderFns } from "./IconSvgASTSFoundation.vue?vue&type=template&id=5348674a&scoped=true&"
import script from "./IconSvgASTSFoundation.vue?vue&type=script&lang=js&"
export * from "./IconSvgASTSFoundation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348674a",
  null
  
)

export default component.exports